var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17.886,
    viewBox: "0 0 23 17.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-home",
    "data-name": "Icon awesome-home",
    d: "M11.194,6.894,3.833,12.957V19.5a.639.639,0,0,0,.639.639l4.474-.012a.639.639,0,0,0,.636-.639V15.667a.639.639,0,0,1,.639-.639h2.555a.639.639,0,0,1,.639.639v3.819a.639.639,0,0,0,.639.641l4.473.012a.639.639,0,0,0,.639-.639V12.952L11.8,6.894A.487.487,0,0,0,11.194,6.894Zm11.628,4.121L19.484,8.263V2.733a.479.479,0,0,0-.479-.479H16.769a.479.479,0,0,0-.479.479v2.9L12.715,2.691a1.917,1.917,0,0,0-2.436,0L.173,11.014a.479.479,0,0,0-.064.675l1.018,1.238a.479.479,0,0,0,.675.065l9.392-7.736a.487.487,0,0,1,.611,0L21.2,12.992a.479.479,0,0,0,.675-.064L22.89,11.69a.479.479,0,0,0-.068-.676Z",
    transform: "translate(0.001 -2.254)",
    fill: "#a0a0a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.94fe5660c4f2c45fc66e63b571ac118e.svg";
export { ForwardRef as ReactComponent };